// Generic Util Methods
function getQueryParam(url, key) {
  var queryStartPos = url.indexOf('?');
  if (queryStartPos === -1) {
    return null;
  }
  var params = url.substring(queryStartPos + 1).split('&');
  for (var i = 0; i < params.length; i++) {
    var pairs = params[i].split('=');
    if (decodeURIComponent(pairs.shift()) == key) {
      return decodeURIComponent(pairs.join('='));
    }
  }
  return null;
}

function setCookie(name, value, days) {
  var expires = "";
  if (days == null) {
    days = 30;
  }
  var date = new Date();
  date.setTime(date.getTime() + (days*24*60*60*1000));
  expires = "; expires=" + date.toUTCString();
  document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

function setShortCookie(name, value) {
  var expires = "";
  var date = new Date();
  date.setTime(date.getTime() + 5*60*1000);
  expires = "; expires=" + date.toUTCString();
  document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i=0;i < ca.length;i++) {
    var c = ca[i];
    while (c.charAt(0)==' ') c = c.substring(1,c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
  }
  return null;
}

function isStoreIdValid(storeId){
	var valid_stores = [];
 	
 	valid_stores.push("beauzelle");
 	
    
 	valid_stores.push("balma-gramont");
 	
    
 	valid_stores.push("montaudran");
 	
    
 	valid_stores.push("livraison-toulouse");
 	
    
 	valid_stores.push("la-pilaterie");
 	
    
 	valid_stores.push("livraison-lille");
 	
    
 	valid_stores.push("labege");
 	
    
 	valid_stores.push("point-relais-bulle-canejan");
 	
    
 	valid_stores.push("portet");
 	
    
 	valid_stores.push("point-relais-abrazzouverts");
 	
    
 	valid_stores.push("point-relais-ponts-jumeaux");
 	
    
 	valid_stores.push("saint-andre-de-cubzac");
 	
    
 	valid_stores.push("point-relais-labouillonnante");
 	
    
 	valid_stores.push("floirac");
 	
    
 	valid_stores.push("libourne");
 	
    
 	valid_stores.push("merignac");
 	
    
 	valid_stores.push("point-relais-ensenat");
 	
    
    
 	valid_stores.push("");
 	
    
 	valid_stores.push("livraison-bordeaux");
 	
    
 	valid_stores.push("point-relais-tournefeuille");
 	
    
 	valid_stores.push("marquette");
 	
    
 	valid_stores.push("point-relais-groupama");
 	
    
 	valid_stores.push("point-relais-ads");
 	
    
    
    
    
    
    

    if(valid_stores.includes(storeId)){
     	return true;
    }else{
    	return false
    }
}

function getSubdomainFromStoreId(storeId){
  var storeIdToSubdomain = {};
 	
 	storeIdToSubdomain["beauzelle"] = "beauzelle";
 	
    
 	storeIdToSubdomain["balma-gramont"] = "balma-gramont";
 	
    
 	storeIdToSubdomain["montaudran"] = "montaudran";
 	
    
 	storeIdToSubdomain["livraison-toulouse"] = "";
 	
    
 	storeIdToSubdomain["la-pilaterie"] = "la-pilaterie";
 	
    
 	storeIdToSubdomain["livraison-lille"] = "";
 	
    
 	storeIdToSubdomain["labege"] = "montaudran";
 	
    
 	storeIdToSubdomain["point-relais-bulle-canejan"] = "merignac";
 	
    
 	storeIdToSubdomain["portet"] = "toulouse-portet";
 	
    
 	storeIdToSubdomain["point-relais-abrazzouverts"] = "merignac";
 	
    
 	storeIdToSubdomain["point-relais-ponts-jumeaux"] = "montaudran";
 	
    
 	storeIdToSubdomain["saint-andre-de-cubzac"] = "merignac";
 	
    
 	storeIdToSubdomain["point-relais-labouillonnante"] = "balma-gramont";
 	
    
 	storeIdToSubdomain["floirac"] = "merignac";
 	
    
 	storeIdToSubdomain["libourne"] = "merignac";
 	
    
 	storeIdToSubdomain["merignac"] = "merignac";
 	
    
 	storeIdToSubdomain["point-relais-ensenat"] = "balma-gramont";
 	
    
    
 	storeIdToSubdomain[""] = "";
 	
    
 	storeIdToSubdomain["livraison-bordeaux"] = "merignac";
 	
    
 	storeIdToSubdomain["point-relais-tournefeuille"] = "beauzelle";
 	
    
 	storeIdToSubdomain["marquette"] = "marquette-lez-lille";
 	
    
 	storeIdToSubdomain["point-relais-groupama"] = "merignac";
 	
    
 	storeIdToSubdomain["point-relais-ads"] = "montaudran";
 	
    
    
    
    
    
    


    return storeIdToSubdomain[storeId];
}


function getUrlFromStoreId(storeId){
  var storeIdToUrl = {};
 	
 	storeIdToUrl["beauzelle"] = "";
 	
    
 	storeIdToUrl["balma-gramont"] = "";
 	
    
 	storeIdToUrl["montaudran"] = "";
 	
    
 	storeIdToUrl["livraison-toulouse"] = "https://omcdkzjxiu6.typeform.com/to/tI8sneGM";
 	
    
 	storeIdToUrl["la-pilaterie"] = "";
 	
    
 	storeIdToUrl["livraison-lille"] = "https://omcdkzjxiu6.typeform.com/to/lG4EmAQo";
 	
    
 	storeIdToUrl["labege"] = "";
 	
    
 	storeIdToUrl["point-relais-bulle-canejan"] = "";
 	
    
 	storeIdToUrl["portet"] = "";
 	
    
 	storeIdToUrl["point-relais-abrazzouverts"] = "";
 	
    
 	storeIdToUrl["point-relais-ponts-jumeaux"] = "";
 	
    
 	storeIdToUrl["saint-andre-de-cubzac"] = "";
 	
    
 	storeIdToUrl["point-relais-labouillonnante"] = "";
 	
    
 	storeIdToUrl["floirac"] = "";
 	
    
 	storeIdToUrl["libourne"] = "";
 	
    
 	storeIdToUrl["merignac"] = "";
 	
    
 	storeIdToUrl["point-relais-ensenat"] = "";
 	
    
    
 	storeIdToUrl[""] = "https://ledrivetoutnu.com/pages/le-super-tout-nu";
 	
    
 	storeIdToUrl["livraison-bordeaux"] = "";
 	
    
 	storeIdToUrl["point-relais-tournefeuille"] = "";
 	
    
 	storeIdToUrl["marquette"] = "";
 	
    
 	storeIdToUrl["point-relais-groupama"] = "";
 	
    
 	storeIdToUrl["point-relais-ads"] = "";
 	
    
    
    
    
    
    


    return storeIdToUrl[storeId];
}


function getStoreIdFromQueryParam(){
 var ldtn_store_param = getQueryParam(window.location.href, "ldtn_store");
  if(isStoreIdValid(ldtn_store_param)){
    return ldtn_store_param;
  }else{
  	return null;
  }
}

function getStoreIdFromCookies(){
 var ldtn_store_cookie = getCookie("ldtn_store");
  if(isStoreIdValid(ldtn_store_cookie)){
    return ldtn_store_cookie;
  }else{
  	return null;
  }
}
